import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AppShell from '../../components/layout/AppShell';
import '../admin/quotes/quote-generator.css';

export default function NewInspection(): React.JSX.Element {
    const navigate = useNavigate();

    useEffect(() => {
        navigate('/admin/work-order/new?jobType=inspection', { replace: true });
    }, [navigate]);

    return (
        <AppShell>
            <div className="quote-page">
                <div className="quote-container" style={{ maxWidth: '700px', textAlign: 'center' }}>
                    <header className="quote-header" style={{ marginBottom: '28px' }}>
                        <div>
                            <h1 style={{ fontSize: '2.5rem', marginBottom: '8px' }}>Redirecting…</h1>
                            <p style={{ color: 'var(--dash-muted)', margin: 0 }}>
                                Opening the unified job creation form.
                            </p>
                        </div>
                    </header>
                </div>
            </div>
        </AppShell>
    );
}
